var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"},style:({textAlign:_vm.option.attribute.textAlign,color:_vm.option.attribute.textColor,fontSize: _vm.option.attribute.textSize+'px',
  fontStyle:_vm.option.attribute.fontStyle, fontWeight:_vm.option.attribute.fontWeight,lineHeight:_vm.option.attribute.textLineHeight+'px',
  backgroundColor:_vm.option.attribute.bgColor,
  fontFamily:_vm.option.attribute.textFamily, textDecoration:_vm.option.attribute.textDecoration}),on:{"click":_vm.redirect}},[_vm._v(" "+_vm._s(_vm.cptData.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }